import Provider from "../Provider";
import MastersContextType from "./MastersContextType";

export default interface MastersProvider extends Provider<MastersContextType> {
}

export const MastersProviderName = "MastersProvider";